<template>
  <div class="mt-3">
    <div class="container-fluid mb-2">
      <div class="row mt-2" style="background-color: white; padding: 10px">
        <div class="col-md-8">
          <h5>Announcement Details</h5>
          <table class="table table-sm">
            <tr>
              <th>Title</th>
              <td>{{ socialMediaDetails.title }}</td>
            </tr>
            <tr>
              <th>Description</th>
              <td>{{ socialMediaDetails.description }}</td>
            </tr>
            <tr>
              <th>URL</th>
              <td>{{ socialMediaDetails.url }}</td>
            </tr>
            <tr>
              <th>Is Loom Video?</th>
              <td>{{ socialMediaDetails.isLoomVideo ? "Yes" : "No" }}</td>
            </tr>
            <tr v-if="socialMediaDetails.assignment_level">
              <th>Assignment Level</th>
              <td>
                <span
                  v-if="socialMediaDetails.assignment_level === 'project_level'"
                  >Project Level</span
                >
                <span
                  v-else-if="
                    socialMediaDetails.assignment_level === 'zone_level'
                  "
                  >Zone Level</span
                >
                <span
                  v-else-if="
                    socialMediaDetails.assignment_level === 'plot_level'
                  "
                  >Plot Level</span
                >
                <span
                  v-else-if="socialMediaDetails.assignment_level === 'general'"
                  >General</span
                >
              </td>
            </tr>
            <template v-if="socialMediaDetails.assignment_level !== 'general'">
              <tr v-if="socialMediaDetails.project_id !== null">
                <th>Project</th>
                <td>{{ socialMediaDetails.project_id.name }}</td>
              </tr>
              <tr v-if="socialMediaDetails.zone_id !== null">
                <th>Zone</th>
                <td>{{ socialMediaDetails.zone_id.code }}</td>
              </tr>
              <tr v-if="socialMediaDetails.plot_id !== null">
                <th>Plot</th>
                <td>{{ socialMediaDetails.plot_id.code }}</td>
              </tr>
            </template>
            <tr>
              <th>Status</th>
              <td>
                <span v-if="socialMediaDetails.status"> Active </span>
                <span v-else> InActive </span>
              </td>
            </tr>
            <tr>
              <th>Created At</th>
              <td>
                {{ socialMediaDetails.created_ts | moment("ddd,Do MMM  YYYY") }}
              </td>
            </tr>
            <tr>
              <th>Images</th>
              <td v-if="socialMediaDetails.images[0] != ''">
                <!-- ENHANCED: Added proper spacing and padding for images -->
                <div class="images-container">
                  <div class="row">
                    <div
                      class="col-lg-4 col-md-6 col-sm-12 mb-3"
                      v-for="(image, index) in socialMediaDetails.images"
                      :key="`image-${index}`"
                    >
                      <div class="image-wrapper">
                        <img
                          :src="image"
                          :alt="`Image ${index + 1}`"
                          class="img-fluid image-item"
                          @click="openImageModal(image)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </td>
              <td v-else class="text-muted">No Images Found</td>
            </tr>
            <tr>
              <th>Videos</th>
              <td v-if="socialMediaDetails.videos[0] != ''">
                <!-- ENHANCED: Added proper spacing and padding for videos -->
                <div class="videos-container">
                  <div class="row">
                    <div
                      class="col-lg-4 col-md-6 col-sm-12 mb-3"
                      v-for="(video, index) in socialMediaDetails.videos"
                      :key="`video-${index}`"
                    >
                      <div class="video-wrapper">
                        <video
                          class="video-item"
                          controls
                          preload="metadata"
                        >
                          <source :src="video" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
              <td v-else class="text-muted">No Videos Found</td>
            </tr>
            <tr>
              <th>PDFs</th>
              <td v-if="socialMediaDetails.pdfs[0] != ''">
              
                <div class="pdfs-container">
                  <div class="row">
                    <div
                      class="col-lg-4 col-md-6 col-sm-12 mb-2"
                      v-for="(pdf, index) in socialMediaDetails.pdfs"
                      :key="`pdf-${index}`"
                    >
                      <a
                        :href="pdf"
                        target="_blank"
                        class="btn btn-outline-primary btn-block pdf-link"
                      >
                        <i class="fas fa-file-pdf text-danger mr-2"></i>
                        {{ getPDFFileName(pdf) }}
                      </a>
                    </div>
                  </div>
                </div>
              </td>
              <td v-else class="text-muted">No PDFs Found</td>
            </tr>
          </table>
        </div>
        <div class="col-md-4 text-right">
          <div class="cover-image-wrapper">
            <img
              :src="socialMediaDetails.image"
              class="img-fluid img-thumbnail cover-image"
              alt="Cover Image"
            />
          </div>
        </div>
      </div>
      <b-row>
        <b-col md="12">
          <b-table
            class="dataTable rounded-left"
            :items="commentsItems"
            :fields="commentsFields"
            :outlined="true"
            head-variant="none"
            table-variant="none"
            :caption-top="true"
            :busy="isBusyComments"
            show-empty
          >
            <template #empty="scope">
              <h4>{{ scope.emptyText }}</h4>
            </template>
            <template #table-caption>Comments</template>
            <template #cell(#)="data">{{ data.index + 1 }}</template>
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template #cell(created_ts)="data">
              {{ data.item.created_ts | moment("DD-MM-YYYY hh:mm:ss A") }}
            </template>

            <template #cell(actions)="row">
              <b-dropdown
                size="sm"
                id="dropdown-1"
                text="Actions"
                variant="primary"
              >
                <b-dropdown-item>
                  <div @click="deleteComment(row.item._id)">Delete Comment</div>
                </b-dropdown-item>

                <comment-reply
                  @comment-success="commentListReload"
                  :index="row.index"
                  :data="row.item"
                />

                <edit-admin-comment
                  @comment-success="commentListReload"
                  :index="row.index"
                  :data="row.item"
                />
                <b-dropdown-item>
                  <div @click="deleteAdminReply(row.item._id)">
                    Delete Reply
                  </div>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <b-modal id="my-modal" title="Reply">
            <b-form-group
              label="Comment"
              label-for="name-input"
              invalid-feedback="Comment is required"
            >
              <b-form-input id="name-input" required></b-form-input>
            </b-form-group>
          </b-modal>
        </b-col>
        <b-col md="12">
          <b-table
            class="dataTable rounded-left"
            :items="likesItems"
            :fields="likesFields"
            :outlined="true"
            head-variant="none"
            table-variant="none"
            :caption-top="true"
            :busy="isBusy"
            show-empty
          >
            <template #empty="scope">
              <h4>{{ scope.emptyText }}</h4>
            </template>

            <template #table-caption>Likes</template>
            <template #cell(#)="data">{{ data.index + 1 }}</template>
            <template #cell(created_ts)="data">
              {{ data.item.created_ts | moment("DD-MM-YYYY hh:mm:ss A") }}
            </template>
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>

    
      <b-modal
        id="image-modal"
        v-model="showImageModal"
        title="Image Preview"
        size="lg"
        hide-footer
        centered
      >
        <div class="text-center">
          <img
            :src="selectedImage"
            class="img-fluid modal-image"
            alt="Preview"
          />
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import commentReply from "../components/social-media/comments/commentReply.vue";
import EditAdminComment from "../components/social-media/comments/editAdminComment.vue";

export default {
  components: { commentReply, EditAdminComment },

  data() {
    return {
      item_per_page: 10,
      perPage: 10,
      currentPage: 1,
      sortDesc: false,
      filter: null,
      isBusy: false,
      isBusyComments: false,
      items: [],
      socialMediaDetails: false,
      commentsFields: [
        "#",

        {
          key: "_user_id.name",
          label: "Name",
        },
        {
          key: "comment",
          label: "Comments",
        },
        {
          key: "admin_comment.comment",
          label: "Admin Comments",
        },
        {
          key: "created_ts",
          label: "Comment Date",
        },
        "actions",
      ],

      likesFields: [
        "#",
        {
          key: "_user_id.name",
          label: "Name",
        },
        {
          key: "created_ts",
          label: "Date",
        },
      ],

      likesItems: [],
      commentsItems: [],
    };
  },
  mounted() {
    this.getOrgDetails();
    this.getComments();
    this.getLikes();
  },
  methods: {
    commentListReload(value) {
      if (value) {
        this.getComments();
      }
    },

    getComments() {
      this.isBusyComments = true;
      let id = this.$route.params.id;
      window.axios.get("comments/" + id).then((resp) => {
        if (resp.data.success) {
          this.commentsItems = resp.data.comments;
          this.isBusyComments = false;
        }
      });
    },

    getLikes() {
      let id = this.$route.params.id;
      window.axios.get("likes/" + id).then((resp) => {
        if (resp.data.success) {
          this.likesItems = resp.data.likes;
        }
      });
    },

    getOrgDetails() {
      let id = this.$route.params.id;
      this.$apiV2.get("announcements/" + id).then((resp) => {
        this.socialMediaDetails = resp.data.data;
      });
    },

    deleteComment(id) {
      const comment_id = id;
      let prompt = confirm("Are you sure want to delete the comment? ");
      if (prompt) {
        window
          .axios({
            method: "delete",
            url: "comments",
            data: {
              comment_id,
            },
          })
          .then((resp) => {
            if (resp.data.success) {
              this.getComments();
            }
          });
      }
    },

    deleteAdminReply(id) {
      const comment_id = id;
      let prompt = confirm("Are you sure want to delete the comment reply? ");
      if (prompt) {
        window
          .axios({
            method: "delete",
            url: "comment/admin",
            data: {
              comment_id,
            },
          })
          .then((resp) => {
            if (resp.data.success) {
              this.getComments();
            }
          });
      }
    },
    getPDFFileName(url) {
      const fileName = url.split("/").pop() || "PDF File";
      return fileName.substring(0, 20) + "...";
    },
  },
};
</script>

<style scoped>
/deep/ .dataTable {
  margin-left: 2px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
}

/deep/ .dataTable thead {
  background-color: #e6e6e6;
  height: 51px;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 3.5%;
  font-family: "Poppins", sans-serif;
  padding-top: 14px;
  padding-bottom: 14px;
}

/deep/ .dataTable {
  text-align: center;
  margin-bottom: 21.5px;
  margin-left: 2px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
}
/deep/ .dataTable tr td {
  font-family: "Poppins", sans-serif;
  font-size: 17px;
  letter-spacing: 3.5%;
  line-height: 25.5px;
  font-weight: 400;
  padding-top: 12px;
  padding-bottom: 12px;
}

/deep/ .dataTable caption {
  border-radius: 10px 10px 0 0;
  height: 64px;
  width: 100%;
  background-color: #dcffd9;
  color: #000;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  letter-spacing: 3.5%;
  padding-left: 27px;
  padding-top: 12px;
  padding-bottom: 12px;
  font-size: 25px;
}

.thead {
  background-color: #dcffd9;
}
.images-container {
  width: 100%;
}

.image-wrapper {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.image-wrapper:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.image-item {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.image-item:hover {
  opacity: 0.9;
}

/* Videos Container */
.videos-container {
  width: 100%;
}

.video-wrapper {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.video-item {
  width: 100%;
  height: 150px;
  border-radius: 8px;
  object-fit: cover;
}

/* PDFs Container */
.pdfs-container {
  width: 100%;
}

.pdf-link {
  padding: 10px 15px;
  border-radius: 6px;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pdf-link:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.2);
  text-decoration: none;
}

/* Cover Image */
.cover-image-wrapper {
  position: relative;

}

.cover-image {
  max-height: 400px;
  width: 100%;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Modal Image */
.modal-image {
  max-height: 70vh;
  width: auto;
  border-radius: 8px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .image-item,
  .video-item {
    height: 120px;
  }
  
  .cover-image {
    max-height: 250px;
  }
  
  .pdf-link {
    font-size: 14px;
    padding: 8px 12px;
  }
}

@media (max-width: 576px) {
  .image-item,
  .video-item {
    height: 100px;
  }
  
  .cover-image {
    max-height: 200px;
  }
}

/* Table row spacing */
.table td {
  vertical-align: top;
  padding: 12px 8px;
}

.table th {
  width: 150px;
  min-width: 120px;
  font-weight: 600;
  color: #495057;
}
</style>
